import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './search.sass';
import { memo, useCallback, useRef, useState } from 'react';
import * as classnames from 'classnames';
import { IconButton } from '@mui/material';
import { useMap } from 'react-leaflet';
import { l2a } from 'shared/map/lib/utils';
import { yandexMapSearch, } from 'shared/map/ui/components/control-buttons/components/search/yandex-search';
import { preventDefault } from 'shared/hooks/utils';
export const SearchControl = memo(function SearchControl(props) {
    const { onSearchDone } = props;
    const [hidden, setHidden] = useState(true);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [text, setText] = useState('');
    const search_input = useRef(null);
    const search_input_div = useRef(null);
    const onButtonClick = useCallback((event) => {
        preventDefault(event);
        if (hidden) {
            setText('');
            window.setImmediate(() => search_input.current?.focus());
        }
        setHidden(!hidden);
    }, [hidden]);
    const map = useMap();
    const doSearch = useCallback(() => {
        const bounds = map.getBounds();
        const geo_bounds = [l2a(bounds.getNorthWest()), l2a(bounds.getSouthEast())];
        const query = text.trim();
        if (query.length <= 0) {
            return;
        }
        setLoading(true);
        yandexMapSearch(query, geo_bounds).then((result) => {
            onSearchDone(result);
            setLoading(false);
        }, () => {
            setError(true);
            setLoading(false);
        });
    }, [map, text]);
    return (_jsxs("div", { className: "ui-map-search", ref: search_input_div, children: [_jsxs("div", { className: classnames('ui-map-search-field-container', {
                    hidden: hidden,
                }), children: [_jsx("div", { className: "ui-map-search-field-button", onClick: () => doSearch() }), _jsx("input", { ref: search_input, type: "text", className: classnames('ui-map-search-field', {
                            error: error,
                        }), placeholder: "\u0410\u0434\u0440\u0435\u0441...", disabled: loading, value: text, onChange: (event) => setText(event.target.value), onKeyDown: (event) => {
                            setError(false);
                            if (event.key === 'Enter')
                                doSearch();
                        } })] }), _jsx(IconButton, { disableRipple: true, "aria-controls": "search", className: "ui-icon-map-button-search", title: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443", onClick: onButtonClick, size: "large" })] }));
});
